const NAME = "SPECIAL_PROCESS_EXECUTION";

export default NAME;
